var React = require('react');

function Newtabthin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m63.8125 7c-.523599.0490874-.955337.5701512-.90625 1.09375.049088.5235987.570151.9553374 1.09375.90625h25.5625l-37.28125 37.28125c-.36833.3763-.360981 1.053858.01542 1.42208.376405.368222 1.053961.36068 1.422076-.01583l37.281254-37.28125v25.59375c-.0075.528313.471635 1.014242 1 1.014242s1.007472-.485929 1-1.014242v-28c-.000052-.5235845-.476416-.9999476-1-1-9.390753-.0000014-18.810776 0-28.1875 0zm-56 10c-.4584025.087467-.8207234.5334-.8125 1v74c.0000524.523584.4764155.999948 1 1h74c.523584-.000052.999948-.476416 1-1v-52c.0075-.528313-.471635-1.014242-1-1.014242s-1.007472.485929-1 1.014242v51h-72v-72h51c.528313.0075 1.014242-.471635 1.014242-1s-.485929-1.007472-1.014242-1c-17.391546 0-34.809671 0-52.1875 0z"}));
}

Newtabthin.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 100 125"};

module.exports = Newtabthin;

Newtabthin.default = Newtabthin;
